var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-button',_vm._g(_vm._b({class:['social-btn', _vm.type],attrs:{"aria-label":_vm.type}},'x-button',_vm.$attrs,false),_vm.$listeners),[_c('x-icon',_vm._b({attrs:{"size":"small"}},'x-icon',_vm.icon,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }